<template>
    <div class="field__list" ref="parent">
        <input
            ref="element"
            class="field__input field__input--base field__input--default typography--default color--default"
            v-on="{
                ...( mask && {
                    input: validateMask
                })
            }"
            :placeholder="placeholder"
            @keyup.space="action"
        >
        <div class="field__list__elements display--flex">
            <div
                v-for="(element, index) in list"
                :key="`element-${name}-${index}`"
                class="field__list__element position--relative"
            >
                <span @click="removeElement( element )" class="field__list__remove pointer"></span>
                {{ element }}
            </div>
        </div>
    </div>
</template>

<script>
// packages
import {
    ref,
    reactive,
    onMounted,
    toRefs
} from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

// plugins
import applyMask from '@/plugins/input-mask';

export default {
    props: {
        reset: Boolean,
        defaultValue: String,
        mask: String,
        name: String,
        listValues: Array,
        placeholder: String
    },
    setup ( props, { emit }) {
        // reactive vars
        const element = ref( null );

        const state = reactive({
            list: []
        });

        onMounted( () => {
            // listener para quando for necessário
            // proceder a um reset a input.
            reset({ props, object: element.value, key: 'value' });

            // pré-preenchimento da listaqgem
            if ( props?.listValues?.length )
                state.list = props.listValues;
        });

        // emissão do valor da input para o
        // componente pai.
        const action = $event => {
            const input = $event.target;
            const inputValue = input.value.slice( 0, -1 ); // remoção do espaço

            // Se o email adicionado for igual a um já existente na lista,
            // Não adiciona o email à lista nem envia para o payload.
            if ( state.list.some( value => value === inputValue ) ) {
                input.value = ''; // dá reset ao valor da input
                return;
            }

            addValueToList( inputValue ); // adiciona o novo valor à lista
            input.value = ''; // dá reset ao valor da input
            emit( 'input', state.list );
        };

        // Adição do valor introduzido à lista.
        const addValueToList = value => state.list.push( value );

        // validação da mascára.
        const validateMask = () => {
            const newValue = element.value.value;
            element.value.value = applyMask( newValue, props.mask );
        };

        // Remover elemento da lista e do payload
        const removeElement = targetElement => {
            state.list = state.list.filter( listElement => listElement !== targetElement );
            emit( 'input', state.list );
        };

        return {
            element,
            action,
            validateMask,
            removeElement,
            ...toRefs( state )
        };
    }
};
</script>

<style lang="scss">
    .field {
        &__list {
            &__elements {
                flex-wrap: wrap;
                gap: 10px;
                margin-top: 10px;
            }
            &__element {
                @include rounded-corner( 8px );
                @include elements-colors ( $color-green-light, $color-green );
                @include sentence-cut();
                padding: 5px 5px 5px 33px;
            }
            &__remove{
                position: absolute;
                left: 0;
                top: 11px;
                width: 32px;
                height: 32px;
                &:before, &:after {
                    position: absolute;
                    left: 15px;
                    content: ' ';
                    height: 15px;
                    width: 2px;
                    background-color: $color-green;
                }
                &:before {
                    transform: rotate(45deg);
                }
                &:after {
                    transform: rotate(-45deg);
                }
            }
        }
    }
</style>